import ISQLiteResponse from "../interfaces/ISQLiteResponse";

const SQLiteHelperService = {

    convertToJsTypes: (queryObject:any) => {
        let convertedObject: any = {...queryObject};
        
        // Remove NULL
        Object.keys(convertedObject).forEach(key => convertedObject[key] === null && delete convertedObject[key]);

        // Fix DATES
        if(convertedObject.createdDate) { convertedObject.createdDate = new Date(convertedObject.createdDate) };
        if(convertedObject.modifiedDate) { convertedObject.modifiedDate = new Date(convertedObject.modifiedDate) };
        if(convertedObject.notActiveDate) { convertedObject.notActiveDate = new Date(convertedObject.notActiveDate) };
        if(convertedObject.dateDisplayed) { convertedObject.dateDisplayed = new Date(convertedObject.dateDisplayed) };
        if(convertedObject.startDate) { convertedObject.startDate = new Date(convertedObject.startDate) };
        if(convertedObject.sortDate) { convertedObject.sortDate = new Date(convertedObject.sortDate) };

        // Fix Array
        if(convertedObject.completedSessions) { convertedObject.completedSessions = JSON.parse(convertedObject.completedSessions) };
        if(convertedObject.prayingUserIds) { convertedObject.prayingUserIds = JSON.parse(convertedObject.prayingUserIds) };
        if(convertedObject.likesUserIds) { convertedObject.likesUserIds = JSON.parse(convertedObject.likesUserIds) };
        if(convertedObject.comments) { convertedObject.comments = JSON.parse(convertedObject.comments) };

        // Fix Objects
        if(convertedObject.userFellowshipGroups) { convertedObject.userFellowshipGroups = JSON.parse(convertedObject.userFellowshipGroups) };

        return convertedObject;
    },
    
    convertToSqlQueryValues: (values: any[]) => {
        return values.map((value) => {
            let convertedValue = undefined;
            switch (typeof value) {
                case 'string':
                    // replace all " with '
                    convertedValue = `"${value.split(`"`).join(`'`)}"`;
                    break;
                case 'number':
                    convertedValue = `${value}`;
                    break;
                case 'boolean': 
                    convertedValue = `${value}`
                    break;
                case 'object':
                    if(Array.isArray(value)) {
                        convertedValue = `'${JSON.stringify(value).replace(/'/g, "''")}'`;
                    } else if (Object.prototype.toString.call(value) === '[object Date]') {
                        convertedValue = `${value.getTime()}`;
                    } else {
                        convertedValue = `'${JSON.stringify(value).replace(/'/g, "''")}'`;
                    }
                    break;
                case 'undefined':
                    convertedValue = 'NULL'
                    break;
            }
            return convertedValue;
        })
    },

    insertQuery: (tableName: string, insertObject:any) => {
        const objectKeys = Object.keys(insertObject).map((key) => `\`${key}\``);
        const objectValues = SQLiteHelperService.convertToSqlQueryValues(Object.values(insertObject));
        const sqlQuery = `INSERT INTO ${tableName} (${objectKeys.toString()}) VALUES (${objectValues.toString()})`;
        console.log(sqlQuery);
        return sqlQuery;
    },

    replaceQuery: (tableName: string, replaceObject:any) => {
        const objectKeys = Object.keys(replaceObject).map((key) => `\`${key}\``);
        const objectValues = SQLiteHelperService.convertToSqlQueryValues(Object.values(replaceObject));
        const sqlQuery = `REPLACE INTO ${tableName} (${objectKeys.toString()}) VALUES (${objectValues.toString()})`;
        console.log(sqlQuery);
        return sqlQuery;
    },

    updateQuery: (tableName: string, updateObject:any, whereKey?: string) => {
        
        const queryObject = {...updateObject}
        delete queryObject.id;
        const objectKeys = Object.keys(queryObject).map((key) => `\`${key}\``);;
        const objectValues = SQLiteHelperService.convertToSqlQueryValues(Object.values(queryObject));
        let queryKeyValueSet = '';
        objectKeys.forEach((key, idx) => queryKeyValueSet += idx ? `, ${key}=${objectValues[idx]}` : `${key}=${objectValues[idx]}`);
        let sqlQuery = `UPDATE ${tableName} SET ${queryKeyValueSet}`;

        if(whereKey) {
            let convertedQueryObject: any = {};
            objectKeys.forEach((key, idx) => convertedQueryObject[key] = objectValues[idx]);
            sqlQuery = sqlQuery + ` WHERE \`${whereKey}\`=${convertedQueryObject[whereKey]}`;
        } else {
            sqlQuery = sqlQuery + ` WHERE \`id\`=${updateObject.id}`;
        }
        console.log(sqlQuery);
        return sqlQuery;
    },

    queryResultToArray: (queryResult: ISQLiteResponse<any>, convertToJsTypes: boolean = false) => {
        const output: Array<any> = [] 
        for(let i = 0; i < queryResult.rows.length; i++ ){
            const convertObject = convertToJsTypes ? SQLiteHelperService.convertToJsTypes(queryResult.rows.item(i)) : queryResult.rows.item(i);
            output.push(convertObject);
        }
        console.log(output);
        return output;
    }
}

export default SQLiteHelperService;